'use client'

import Box from '@mui/material/Box'

interface BookingProgressBarProps {
  currentStep: number
  totalSteps: number
}

export const BookingProgressBar: React.FC<BookingProgressBarProps> = ({
  currentStep,
  totalSteps,
}) => {
  const progress = (currentStep / totalSteps) * 100

  return (
    <Box
      sx={{
        width: '100%',
        height: 18,
        bgcolor: 'rgba(0, 0, 0, 0.12)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: `${progress}%`,
          bgcolor: '#A1BBFF',
          transition: 'width 0.4s ease-in-out',
        }}
      />
    </Box>
  )
}
